import config from 'Config/index';
import { getKeyValue } from 'Src/i18n';

const pledgApiPath = `${config.get('psp.pledg.api_path')}/${config.get('psp.pledg.merchand_id')}`;

export const isPledgAllowed = ({ price }: { price: number }) => {
  const MAXIMUM_PLEDG_AMOUNT = getKeyValue('booking.banking.paymentSchedule.bnpl.pledgMaxAmount');
  return price <= MAXIMUM_PLEDG_AMOUNT;
};

export const fetchPledg = (endpoint, options) =>
  fetch(`${pledgApiPath}${endpoint}`, options).then((response) => response.json());
